import { withViewComponent } from '@updater-legacy/components/custom-element';
import styles from './index.css';

const SELECTED_INDEX = 'selected-index';

function isCondensed(value) {
  return value && typeof value[0] === 'string';
}

export default class StepList extends withViewComponent(styles)() {
  static props = ['value'];
  static get observedAttributes() {
    return [SELECTED_INDEX];
  }

  get selectedIndex() {
    return parseInt(this.getAttribute(SELECTED_INDEX), 10);
  }

  set selectedIndex(newValue) {
    this.setAttribute(SELECTED_INDEX, newValue);
  }

  updated({ value }) {
    const condensed = isCondensed(value);

    this.render`
      ${value.map(
        (step, i) => this.wire(condensed ? step : step.name)`
        <div class="step">
          <div class="circle">${i + 1}</div>
          <span class="name">${step.name || step}</span>
          ${
            !condensed
              ? this.wire(`${step.name}:details`)`
              <span class="description">${step.description}</span>
              <span class="time">${step.time}</span>
            `
              : ''
          }
        </div>
        `
      )}
    `;
    Array.from(this.shadowRoot.querySelectorAll('.step')).forEach(
      (element, index) => {
        // IE11 stupidity
        // https://github.com/webcomponents/shadydom/issues/211
        if (condensed) {
          element.setAttribute('condensed', '');
        } else {
          element.removeAttribute('condensed');
        }

        // TODO: Can't set this class in hyperhtml b/c it will remove ShadyCSS classes.
        if (index === this.selectedIndex) {
          element.classList.add('selected');
        } else {
          element.classList.remove('selected');
        }
      }
    );
  }
}

customElements.define('upd-step-list', StepList);
